import { useTranslation } from "react-i18next";
import { ColumnLevelFilter } from "../../../page/ProductsPage/ColumnLevelFilter";
import { useInvestments } from "../../../services/productsService";

/**
 * Reusable investment filter component that fetches investments
 * and displays them in a dropdown filter
 */
export const InvestmentFilter = (props) => {
    const { searchParams, setSearchParams, filterName, InputLabelStyle, maxHeight } = props;
    const { t } = useTranslation();
    const { data: investments } = useInvestments();

    const investmentOptions = investments?.results ?? [];
    const columnValues = investmentOptions.map((investment) => investment.id);
    const columnDisplayValues = investmentOptions.map(
        (investment) => investment.investment_name_sales,
    );

    return (
        <ColumnLevelFilter
            label={t("products.investment")}
            columnValues={columnValues}
            columnDisplayValues={columnDisplayValues}
            columnName={filterName || "investment"}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            InputLabelStyle={InputLabelStyle}
            maxHeight={maxHeight}
        />
    );
};
